// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dMTw15 {
  max-width: 540px;
  min-width: 540px;
  width: 100%;
}

.CFirP1 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2-5, 20px);
}

.SyMUEY {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 14px);
  line-height: 1.8;
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  white-space: pre-line;
}

.hhc72Q {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.e86ECL {
  height: 40px;
  min-width: 218px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  background: var(--brand-tr-orange, #d64000);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-neutral-white, #ffffff);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-md, 14px);
  cursor: pointer;
  transition: all 0.2s ease;
}

.e86ECL:hover {
  background: var(--brand-tr-orange-dark, #b33600);
  border-color: var(--brand-tr-orange-dark, #b33600);
}

.fo7krk {
  height: 40px;
  min-width: 218px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  background: var(--surface-neutral-white, #ffffff);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-primary-medium, #1f1f1f);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-md, 14px);
  cursor: pointer;
  transition: all 0.2s ease;
}

.fo7krk:hover {
  background: var(--surface-neutral-pale, #f5f5f5);
}

@media (max-width: 768px) {
  .dMTw15 {
    max-width: 90vw;
    margin: var(--spacing-2, 16px);
  }

  .CFirP1 {
    gap: var(--spacing-3, 24px);
  }

  .SyMUEY {
    font-size: var(--font-size-sm, 14px);
  }

  .e86ECL,
  .fo7krk {
    min-width: 180px;
    height: 44px;
    font-size: var(--font-size-sm, 14px);
  }
}

@keyframes ldmdcP {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/AccountsPayableDeleteModal/AccountsPayableDeleteModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uDAAuD;EACvD,+CAA+C;EAC/C,2CAA2C;EAC3C,iDAAiD;EACjD,yCAAyC;EACzC,oCAAoC;EACpC,6CAA6C;EAC7C,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uDAAuD;EACvD,+CAA+C;EAC/C,iDAAiD;EACjD,iDAAiD;EACjD,0CAA0C;EAC1C,oCAAoC;EACpC,6CAA6C;EAC7C,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".deleteAccountsPayableModal {\n  max-width: 540px;\n  min-width: 540px;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2-5, 20px);\n}\n\n.message {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 14px);\n  line-height: 1.8;\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  white-space: pre-line;\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.deleteButton {\n  height: 40px;\n  min-width: 218px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  background: var(--brand-tr-orange, #d64000);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-neutral-white, #ffffff);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-md, 14px);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.deleteButton:hover {\n  background: var(--brand-tr-orange-dark, #b33600);\n  border-color: var(--brand-tr-orange-dark, #b33600);\n}\n\n.cancelButton {\n  height: 40px;\n  min-width: 218px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  background: var(--surface-neutral-white, #ffffff);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-primary-medium, #1f1f1f);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-md, 14px);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cancelButton:hover {\n  background: var(--surface-neutral-pale, #f5f5f5);\n}\n\n@media (max-width: 768px) {\n  .deleteAccountsPayableModal {\n    max-width: 90vw;\n    margin: var(--spacing-2, 16px);\n  }\n\n  .content {\n    gap: var(--spacing-3, 24px);\n  }\n\n  .message {\n    font-size: var(--font-size-sm, 14px);\n  }\n\n  .deleteButton,\n  .cancelButton {\n    min-width: 180px;\n    height: 44px;\n    font-size: var(--font-size-sm, 14px);\n  }\n}\n\n@keyframes contentFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteAccountsPayableModal": `dMTw15`,
	"content": `CFirP1`,
	"message": `SyMUEY`,
	"actions": `hhc72Q`,
	"deleteButton": `e86ECL`,
	"cancelButton": `fo7krk`,
	"contentFadeIn": `ldmdcP`
};
module.exports = ___CSS_LOADER_EXPORT___;
